<script setup>
import { useRoute } from 'vue-router'
import AppIcon from '@/components/AppIcon.vue'
import { isNavActive, tabNavItems } from '@/navigation'

const route = useRoute()

function isActive(item) {
  return isNavActive(route.path, item)
}
</script>

<template>
  <nav class="tb" aria-label="Primary">
    <RouterLink
      v-for="t in tabNavItems"
      :key="t.to"
      :to="t.to"
      class="tb-tab"
      :class="{ 'tb-tab--active': isActive(t) }"
    >
      <AppIcon class="tb-icon" :paths="t.icon" />
      <span class="tb-label">{{ t.label }}</span>
    </RouterLink>
  </nav>
</template>

<style scoped>
.tb {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  z-index: 50;
  display: flex;
  justify-content: space-around;
  border-top: 1px solid var(--hairline);
  background: var(--paper);
  box-shadow: 0 -10px 28px rgba(var(--ink-rgb), 0.06);
  padding: var(--space-xs) var(--space-xs) calc(var(--space-xs) + env(safe-area-inset-bottom, 0px));
}
.tb-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-height: 52px;
  border-radius: var(--radius-md);
  color: var(--muted);
  font-size: var(--text-xs);
  font-weight: 800;
  text-decoration: none;
  transition:
    background-color var(--motion-fast) var(--ease-out),
    color var(--motion-fast) var(--ease-out),
    transform var(--motion-fast) var(--ease-press);
}
.tb-icon {
  width: 21px;
  height: 21px;
  transition: color var(--motion-fast) var(--ease-out), transform var(--motion-fast) var(--ease-press);
}
.tb-label {
  max-width: 68px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tb-tab--active {
  background: rgba(var(--gold-rgb), 0.12);
  color: var(--ink);
}
.tb-tab--active .tb-icon {
  color: var(--someday-gold);
}
.tb-tab:hover {
  background: rgba(var(--gold-rgb), 0.08);
  color: var(--ink);
}
.tb-tab:hover .tb-icon {
  transform: translateY(-1px);
}
.tb-tab:active {
  transform: translateY(1px) scale(0.98);
}
@media (min-width: 768px) {
  .tb { display: none; }
}
</style>
